import { Box } from '@mui/material';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import { getDetailedViewTicketSummary } from 'store/ticket-service/selector';
import { ISummaryStory } from 'store/ticket-service/types';

import { flexMixin } from 'utils/flexMixin';

import { UserStoryDropdown } from 'components/shared/CustomDropdown/UserStoryDropdown/UserStoryDropdown';

import { DetailedStoryView } from './DetailedStoryView';

interface GeneralStepSummaryProps {
	ticketSummaries: Array<ISummaryStory>;
}

const UserStoriesList: FC<GeneralStepSummaryProps> = ({ ticketSummaries }) => {
	const detailedViewTicketSummary = useSelector(getDetailedViewTicketSummary);

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px', width: '100%' }}>
			<Box
				sx={{
					...flexMixin({ direction: 'column', justify: 'flex-start' }),
					wordWrap: 'break-word',
					whiteSpace: 'pre-line',
					paddingRight: '10px',
					boxShadow: '0px 4px 16px 0px #2867830F',
					width: detailedViewTicketSummary === null ? '100%' : '50%',
				}}
			>
				{ticketSummaries?.map((summary, index) => (
					<UserStoryDropdown
						key={summary?.id || index}
						index={index + 1}
						userStory={summary}
						isLast={index === ticketSummaries.length - 1}
					/>
				))}
			</Box>
			{detailedViewTicketSummary !== null ? (
				<DetailedStoryView
					scenarios={detailedViewTicketSummary?.summaryScenarios || []}
					acceptanceCriteria={detailedViewTicketSummary?.summaryAcceptanceCriteria || []}
				></DetailedStoryView>
			) : null}
		</Box>
	);
};

export default memo(UserStoriesList);
